// External Dependencies
import styled from 'styled-components';

// Local Typings
interface Props {
  children: React.ReactNode;
}

// Local Variables
const StyledRoot = styled.div({
  width: '100%',
});

// Component Definition
const FullWidthDiv = ({ children }: Props): JSX.Element => {
  return (
    <StyledRoot>
      {children}
    </StyledRoot>
  );
};

export default FullWidthDiv;
